/**
 * Loại task
 * NVTUAN1 18.12.2023
 */
export default {
  CalcInOutward: 1, //Tính giá xuất kho
  ReOrderRefNo: 3, //Đánh lại số chứng từ
  PostBatch: 4, //Ghi sổ theo lô/Bỏ ghi sổ theo lô
  CloseBook: 5, //Khóa sổ
  ReBuild: 9, //Bảo trì dữ liệu
  SortRefNo: 10, //Sắp xếp số chứng từ
};
